import { render } from "./AnimalAdd.vue?vue&type=template&id=4eecef5f"
import script from "./AnimalAdd.vue?vue&type=script&lang=js"
export * from "./AnimalAdd.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__